import { render } from "./List.vue?vue&type=template&id=2629c1de&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=2629c1de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2629c1de"

export default script